import React from 'react';
import {OrderHistoryContent} from './sub-view/order-history-content';
import {UserLayout} from 'components/layouts/user';

class OrderHistoryContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <UserLayout active="user-order-history">
        <h1 className="user-header">Lịch sử giao dịch</h1>
        <OrderHistoryContent/>
      </UserLayout>
    );
  }
}

export default OrderHistoryContainer;



// WEBPACK FOOTER //
// ./components/users/OrderHistoryContainer.jsx